module.exports = __webpack_public_path__ + "img/address_ly.ce511507.png";